import TestCarouselModule from './TestCarouselModule';
// import AccordionModule from './AccordionModule.jsx';
// import AnchorBarModule from './AnchorBarModule.jsx';
// import AvailabilityBarModel from './AvailabilityBarModel.jsx';
// import BannerAndMediaModule from './BannerAndMediaModule.jsx';
// import BannerFullBleedModule from './BannerFullBleedModule.jsx';
// import BannerSlimModule from './BannerSlimModule.jsx';
// import BreadcrumbsModel from './BreadcrumbsModel.jsx';
// import CardCarouselFocusModule from './CardCarouselFocusModule.jsx';
// import CardCarouselGenericModule from './CardCarouselGenericModule.jsx';
// import CardCarouselOutOfScreenModule from './CardCarouselOutOfScreenModule.jsx';
// import CardListingGridModule from './CardListingGridModule.jsx';
// import CardListItemsModule from './CardListItemsModule.jsx';
// import ContactsModule from './ContactsModule.jsx';
// import CTabreakModule from './CTabreakModule.jsx';
// import CTabreakWithLogoModule from './CTabreakWithLogoModule.jsx';
// import EmbedModule from './EmbedModule.jsx';
// import FooterHorizontal from './FooterHorizontal.jsx';
// import FooterVertical from './FooterVertical';
// import FormModule from './FormModule.jsx';
// import Header from './Header.jsx';
// import HeadingSideModule from './HeadingSideModule.jsx';
// import HeadingVerticalModule from './HeadingVerticalModule';
// import HeroArticleModuleModel from './HeroArticleModuleModel.jsx';
// import HeroCarouselCentreAlignedModule from './HeroCarouselCentreAlignedModule.jsx';
// import HeroCarouselLeftAlignedModule from './HeroCarouselLeftAlignedModule.jsx';
// import HeroCenterAlignedModule from './HeroCenterAlignedModule.jsx';
import AccordionModule from './AccordionModule';
import CTABreakModule from './CTABreakModule';
import HeroFullBleedModule from './HeroFullBleedModule';
import RichTextModule from './RichTextModule';
// import HeroLeftAlignedModule from './HeroLeftAlignedModule.jsx';
// import HeroSlimCenterAlignedModule from './HeroSlimCenterAlignedModule.jsx';
// import HeroSlimLeftAlignedModule from './HeroSlimLeftAlignedModule.jsx';
// import HeroWithTwoMediaModule from './HeroWithTwoMediaModule.jsx';
// import IconListModule from './IconListModule.jsx';
// import IconListWithMediaModule from './IconListWithMediaModule.jsx';
// import IconListWithRichTextModule from './IconListWithRichTextModule.jsx';
// import ListAndMediaModule from './ListAndMediaModule.jsx';
// import ListRichTextModule from './ListRichTextModule.jsx';
// import ListTwoMediaModule from './ListTwoMediaModule.jsx';
// import LogoListModule from './LogoListModule.jsx';
// import MapFullBleedModule from './MapFullBleedModule.jsx';
// import MapSimpleModule from './MapSimpleModule.jsx';
// import MediaCarouselFullBleedModule from './MediaCarouselFullBleedModule.jsx';
// import MediaCarouselModule from './MediaCarouselModule.jsx';
// import MediaColumnsLandscapeModule from './MediaColumnsLandscapeModule.jsx';
// import MediaColumnsPortraitModule from './MediaColumnsPortraitModule.jsx';
// import MediaMasonryGridModule from './MediaMasonryGridModule.jsx';
// import QuoteCarouselModule from './QuoteCarouselModule.jsx';
// import QuoteModule from './QuoteModule.jsx';
// import QuoteWithMediaModule from './QuoteWithMediaModule.jsx';
// import RichTextAndMediaOnFullBleedModule from './RichTextAndMediaOnFullBleedModule.jsx';
// import RichTextAndOneMediaModule from './RichTextAndOneMediaModule.jsx';
// import RichTextAndTwoMediaModule from './RichTextAndTwoMediaModule.jsx';
// import RichTextAndTwoPortraitStackedModule from './RichTextAndTwoPortraitStackedModule.jsx';
// import RichTextColumnsModule from './RichTextColumnsModule.jsx';
// import RichTextModule from './RichTextModule.jsx';
// import RichTextWithMediaModule from './RichTextWithMediaModule.jsx';
// import TabsModule from './TabsModule.jsx';

const Modules: any = {
  TestCarouselModule,
  AccordionModule,
  //   AnchorBarModule,
  // AvailabilityBarModel,
  // BannerAndMediaModule,
  // BannerFullBleedModule,
  // BannerSlimModule,
  // BreadcrumbsModel,
  // CardCarouselFocusModule,
  // CardCarouselGenericModule,
  // CardCarouselOutOfScreenModule,
  // CardListingGridModule,
  // CardListItemsModule,
  // ContactsModule,
  CTABreakModule,
  // CTabreakWithLogoModule,
  // EmbedModule,
  // FooterHorizontal,
  // FooterVertical,
  // FormModule,
  // Header,
  // HeadingSideModule,
  // HeadingVerticalModule,
  // HeroArticleModuleModel,
  // HeroCarouselCentreAlignedModule,
  // HeroCarouselLeftAlignedModule,
  // HeroCenterAlignedModule,
  HeroFullBleedModule,
  // HeroLeftAlignedModule,
  // HeroSlimCenterAlignedModule,
  // HeroSlimLeftAlignedModule,
  // HeroWithTwoMediaModule,
  // IconListModule,
  // IconListWithMediaModule,
  // IconListWithRichTextModule,
  // ListAndMediaModule,
  // ListRichTextModule,
  // ListTwoMediaModule,
  // LogoListModule,
  // MapFullBleedModule,
  // MapSimpleModule,
  // MediaCarouselFullBleedModule,
  // MediaCarouselModule,
  // MediaColumnsLandscapeModule,
  // MediaColumnsPortraitModule,
  // MediaMasonryGridModule,
  // QuoteCarouselModule,
  // QuoteModule,
  // QuoteWithMediaModule,
  // RichTextAndMediaOnFullBleedModule,
  // RichTextAndOneMediaModule,
  // RichTextAndTwoMediaModule,
  // RichTextAndTwoPortraitStackedModule,
  // RichTextColumnsModule,
  RichTextModule,
  // RichTextWithMediaModule,
  // TabsModule,
};

export default Modules;
